import { createSelector } from 'reselect';

import getElectDecoratedConsumptionDataSelector from './getElectDecoratedConsumptionDataSelector';

export default createSelector([getElectDecoratedConsumptionDataSelector], (data) => {
  const totalCarbonEmissions = data.reduce((total, item) => {
    return total + (item?.attachedLocation?.aggregated_tonnage || 0);
  }, 0);

  const certificateTotal = data.reduce((total, item) => {
    if (!item.certificates?.length) {
      return total;
    }
    const certificateTotalByLine = item.certificates.reduce((certTotal, certEntry) => {
      return certTotal + certEntry.applied_energy_kwh;
    }, 0);
    return total + certificateTotalByLine;
  }, 0);

  const totalKwhCoveredByCertificate = data.reduce((total, item) => {
    if (!item.certificates?.length) {
      return total;
    }
    const locationMultiplier = item?.attachedLocation?.spaceRatio || 1;
    return total + ((item.activity_quantity_kwh || 0) + (item.supplier_quantity_kwh || 0)) * locationMultiplier;
  }, 0);

  const totalKwhNotCoveredByCertificate = data.reduce((total, item) => {
    if (item.certificates?.length) {
      return total;
    }
    const locationMultiplier = item?.attachedLocation?.spaceRatio || 1;

    return total + ((item.activity_quantity_kwh || 0) + (item.supplier_quantity_kwh || 0)) * locationMultiplier;
  }, 0);

  const totalKwhOnsiteRenewables = data.reduce((total, item) => {
    return total + (item.onsite_renewable_qty_kwh || 0);
  }, 0);

  return {
    totalCarbonEmissions,
    totalKwhCoveredByCertificate,
    certificateTotal,
    totalKwhNotCoveredByCertificate,
    totalKwhOnsiteRenewables,
  };
});
